import { AcknowledgementDialog } from './AcknowledgementDialog';

export default AcknowledgementDialog;
